export default __webpack_public_path__ + "static/media/out_of_stock.adc855b3.jpg";